import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const articleData: Record<string, {
  title: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  content: string[];
}> = {
  '1': {
    title: '2026年最值得熬夜追的十部国产剧，每一部都让人欲罢不能',
    category: '剧评推荐',
    date: '2026-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collection%20artistic%20collage%2C%20various%20drama%20scenes%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background&width=1200&height=600&seq=article-detail-01&orientation=landscape',
    content: [
      '2026年已经过半，国产剧市场迎来了一个前所未有的繁荣期。从开年的《长安十二时辰》到暑期档的《大江大河3》，精品剧集层出不穷，让无数夜猫子们深陷追剧热潮。',
      '作为一名资深夜猫子和影视内容创作者，我熬夜刷完了今年所有的热播剧，精选出这十部真正值得你牺牲睡眠去追的佳作。每一部都有着独特的魅力和不可替代的观影价值。',
      '第一名当属《长安十二时辰》，这部剧以盛唐为背景，将悬疑探案与历史史诗完美融合。精良的制作、考究的服饰道具、演员们精湛的演技，每一帧画面都堪称艺术品。深夜独自观看时，仿佛真的穿越回了那个繁华的大唐盛世。',
      '紧随其后的是《大江大河3》，延续了前两部的现实主义风格，讲述了中国改革开放浪潮中普通人的命运沉浮。宋运辉的故事让人热泪盈眶，那些关于理想、坚守和奋斗的瞬间，在深夜里格外打动人心。',
      '第三名推荐《大明风华录》，一部制作精良的古装权谋剧。不同于以往宫廷剧的套路，这部剧在历史考据上下了真功夫，剧情环环相扣，每一次反转都出人意料。深夜追剧时，你绝对会被它的剧情牢牢抓住。',
      '喜欢悬疑类型的夜猫子绝对不能错过《迷雾追踪》。这部剧以一座小城中的连环案件为线索，层层递进的叙事结构和精心设计的悬念，让人一口气追完停不下来。建议不要在凌晨三点开始看第一集，因为你会忍不住看到天亮。',
      '此外，《青春不留白》《深海密码》《食神2026》《边疆风云》等剧也各具特色。青春剧的温暖治愈、悬疑剧的烧脑刺激、美食剧的治愈暖心、军旅剧的热血激昂，总有一款适合你的深夜时光。',
      '深夜是一天中最安静的时刻，也是最能沉浸于好故事的时光。打开夜猫电影院，备好零食和饮料，让这些精彩的国产剧陪你度过每一个美好的夜晚吧。',
    ],
  },
  '2': {
    title: '深夜影院观影指南：如何打造完美的家庭影院体验',
    category: '观影指南',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20with%20large%20screen%20and%20comfortable%20seating%2C%20ambient%20LED%20lighting%2C%20dark%20cinematic%20atmosphere%2C%20premium%20audio%20setup&width=1200&height=600&seq=article-detail-02&orientation=landscape',
    content: [
      '对于热爱深夜观影的夜猫子来说，拥有一个舒适的家庭影院环境，能让观影体验提升好几个档次。不需要花费巨额资金，只要掌握一些小技巧，就能打造出属于自己的专属影院。',
      '首先是显示设备的选择。如果你预算充足，一台65英寸以上的4K电视是最佳选择。对于租房或空间有限的夜猫子，一台优质的投影仪搭配白墙也能获得不错的沉浸感。深夜观影时，记得将亮度调节到舒适的水平。',
      '音响系统是家庭影院的核心。一套5.1声道的环绕音响能让你真正沉浸在电影的世界中。但如果你和大多数夜猫子一样在深夜观影怕打扰家人或邻居，一副高品质的降噪耳机是更实际的选择。',
      '灯光布置同样重要。在屏幕后方安装一条可调色温的LED灯带，不仅能营造影院般的高级感，还能有效减轻长时间观影带来的眼部疲劳。选择暖色调的灯光，让深夜观影更加温馨舒适。',
      '最后，舒适的座椅和随手可及的零食饮料是好体验的基石。一张可以半躺的沙发椅，一条柔软的毛毯，再加上几包薯片和一杯热茶，这就是深夜影院最完美的打开方式。',
    ],
  },
  '3': {
    title: '动作片爱好者的狂欢：今夏最燃打斗场面大盘点',
    category: '电影盘点',
    date: '2026-07-22',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Explosive%20action%20movie%20fight%20scenes%20montage%2C%20dynamic%20cinematic%20moments%2C%20dramatic%20orange%20and%20dark%20lighting%2C%20thrilling%20movie%20collage&width=1200&height=600&seq=article-detail-03&orientation=landscape',
    content: [
      '夏天是动作片的黄金季节，今年暑期档的动作电影更是燃到炸裂。从科幻巨制到现实题材，每一部的打斗场面都让人肾上腺素飙升。',
      '《流浪地球3》中的太空救援戏码堪称年度最佳动作场景。在零重力的环境中，吴京饰演的角色在破损的空间站中与时间赛跑，每一个动作设计都经过精密计算，既有物理学的真实感，又不失视觉的震撼力。',
      '《深海异兽》的海底战斗场面同样令人印象深刻。在幽暗的深海环境中，巨型怪兽的庞大身影与人类渺小的身躯形成强烈对比，那种压迫感通过银幕直击观众的内心。深夜关灯观看效果更佳。',
      '对于喜欢传统硬核动作片的观众，《极速追凶》的追车戏绝对不容错过。实景拍摄的真实感和精妙的镜头调度，让这场深夜城市追逐战充满了原始的野性力量。',
      '《暗夜追踪》则将动作与悬疑完美结合，每一场打斗都服务于剧情推进。在雨夜的巷道中，主角与反派的近身格斗干净利落又充满张力，是近年少有的写实风格动作设计。',
      '深夜看动作片有一种独特的爽感——在黑暗中感受银幕上的爆炸、追逐和搏斗，仿佛自己也置身于那个充满刺激的世界。准备好你的爆米花，让这些精彩的动作场面点燃你的夜晚吧。',
    ],
  },
  '4': {
    title: '深夜追剧不伤眼：这些护眼小技巧每个夜猫子都该知道',
    category: '追剧技巧',
    date: '2026-07-20',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20night%20desk%20with%20warm%20lamp%20and%20computer%20screen%2C%20blue%20light%20glasses%2C%20eye%20care%20concept%2C%20soft%20warm%20lighting%2C%20healthy%20lifestyle&width=1200&height=600&seq=article-detail-04&orientation=landscape',
    content: [
      '作为夜猫子，深夜追剧是我们最大的快乐源泉。但长时间在黑暗环境中盯着屏幕，对眼睛的伤害不容忽视。以下这些护眼小技巧，让你在享受深夜观影的同时，也能保护好自己的视力。',
      '开启夜览模式（Night Shift）。无论是手机、平板还是电脑，现代设备都内置了蓝光过滤功能。在深夜时段，开启夜览模式可以有效减少蓝光对眼睛的刺激，同时降低屏幕色温，让画面更加柔和。',
      '遵循20-20-20法则。每看屏幕20分钟，就把视线移向20英尺（约6米）以外的物体，持续20秒。这能有效缓解眼部肌肉的紧张状态。可以在每集结束时的片尾曲时间执行这个小练习。',
      '保持环境光。在完全黑暗的环境中观看明亮的屏幕是眼睛最大的敌人。在屏幕后方放置一盏小夜灯或暖色调台灯，减少屏幕与环境的亮度反差，能显著减轻眼部疲劳。',
      '适当使用人工泪液。深夜长时间注视屏幕会导致眨眼次数减少，眼睛容易干涩。备一瓶不含防腐剂的人工泪液，感觉眼睛干涩时滴上一两滴，让眼睛保持湿润舒适。',
      '最后，热敷是缓解眼部疲劳的最佳方式。追完剧后用温热毛巾敷眼5-10分钟，促进眼周血液循环，让眼睛得到充分放松。毕竟，保护好眼睛，才能继续做快乐的夜猫子。',
    ],
  },
  '5': {
    title: '鬼吹灯之昆仑神宫：国产恐怖片的新标杆',
    category: '电影盘点',
    date: '2026-07-18',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Adventure%20horror%20movie%20scene%20with%20snowy%20mountains%20and%20ancient%20ruins%2C%20mysterious%20golden%20light%2C%20dark%20atmospheric%20cinematic%20frame&width=1200&height=600&seq=article-detail-05&orientation=landscape',
    content: [
      '《鬼吹灯之昆仑神宫》的上映，标志着国产冒险恐怖片迈上了一个新台阶。这部改编自天下霸唱同名小说的电影，将原著中昆仑山的神秘与恐怖完美呈现于银幕之上。',
      '故事延续了胡八一、王凯旋和Shirley杨的铁三角组合，他们为了寻找传说中的昆仑神宫，踏上了一段惊心动魄的旅程。影片在视觉呈现上令人惊艳，昆仑山的壮美与诡秘交织在一起，营造出强烈的视觉冲击力。',
      '影片最大的亮点在于将中国传统文化中的神话元素与冒险故事巧妙结合。九层妖塔、冰火两重天的古老诅咒、守护神兽的恐怖身影，这些设定既有东方神秘色彩，又具备世界级的视觉呈现。',
      '深夜观看这部电影时，那种身临其境的恐怖感会被放大数倍。特别是在雪崩和地宫探险的段落，精良的音效设计让人仿佛能听到风雪中传来的诡异声响。建议胆小的夜猫子不要一个人深夜观看。',
      '总的来说，《鬼吹灯之昆仑神宫》不仅是一部优秀的恐怖冒险片，更是国产类型片工业化水准的一次重要展示。它证明了中国电影人同样能制作出世界水准的类型大片。',
    ],
  },
  '6': {
    title: '大江大河3：一部献给奋斗者的时代赞歌',
    category: '剧评推荐',
    date: '2026-07-15',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20drama%20scene%20with%20urban%20cityscape%2C%20river%20reflecting%20lights%20at%20dusk%2C%20warm%20golden%20tones%2C%20professional%20cinematic%20frame&width=1200&height=600&seq=article-detail-06&orientation=landscape',
    content: [
      '作为《大江大河》系列的第三部，这部剧延续了前作的高水准，以更加宏大的叙事视角展现了改革开放浪潮中普通中国人的命运变迁。宋运辉、雷东宝、杨巡三个主角的故事线在这一季中交织碰撞，构成了一幅波澜壮阔的时代画卷。',
      '宋运辉的故事依然是全剧的灵魂。从东海化工厂的技术骨干到行业领军人物，他的每一步成长都凝聚着无数个加班的深夜和攻坚的汗水。那些在车间里独自钻研技术的夜晚，是无数中国工程师奋斗的缩影。',
      '雷东宝的乡镇企业之路则展现了另一种奋斗姿态。来自农村的他，凭着过人的胆识和实干精神，在市场经济的浪潮中闯出了一片天地。他的故事告诉每一个深夜还在努力的夜猫子——奋斗从不辜负有心人。',
      '杨巡的个体户创业线则更加贴近普通观众。从摆地摊到开办自己的公司，他的经历充满了起起落落，但那份永不言弃的精神让人动容。每当他深夜独自盘点货物、规划未来的画面，都让人感受到奋斗者的孤独与坚毅。',
      '这部剧最打动人的地方在于它的真实感。没有过度美化的成功，也没有刻意渲染的悲情，每一个角色都在自己的位置上实实在在地生活着、奋斗着。深夜追这部剧时，你会被那种向上的力量所感染。',
      '《大江大河3》不仅是一部优秀的电视剧，更是一面映照时代的镜子。它让我们看到，无论身处何种境遇，保持奋斗的姿态，时代的洪流中总能找到属于自己的方向。这或许就是这部剧献给所有奋斗者最好的礼物。',
    ],
  },
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = id ? articleData[id] : null;

  useEffect(() => {
    if (article) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [id, article]);

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-950">
        <div className="text-center">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-800 mx-auto mb-4">
            <i className="ri-error-warning-line text-3xl text-foreground-500"></i>
          </div>
          <p className="text-foreground-500 text-lg">文章不存在</p>
          <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-400 text-sm">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${article.title} - 夜猫电影院`}</title>
        <meta name="description" content={article.content[0].slice(0, 150)} />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.content[0].slice(0, 150),
            datePublished: article.date,
            author: { '@type': 'Organization', name: '夜猫电影院' },
          })}
        </script>
      </Helmet>

      <main className="min-h-screen bg-background-950 pt-16">
        <article className="max-w-3xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-600 mb-6 flex-wrap">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/category/movies" className="hover:text-primary-500 transition-colors">影视资讯</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-400 truncate max-w-[200px]">{article.title}</span>
          </nav>

          <div className="mb-8">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/10 text-primary-500 mb-4">
              {article.category}
            </span>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-4 leading-tight">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-foreground-600 text-xs md:text-sm">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {article.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                阅读时长 {article.readTime}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                夜猫电影院编辑部
              </span>
            </div>
          </div>

          <div className="relative aspect-[2/1] rounded-xl overflow-hidden mb-8">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="prose-custom">
            {article.content.map((paragraph, i) => (
              <p key={i} className="text-foreground-300 text-sm md:text-base leading-relaxed mb-5">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/30">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800">
                  <i className="ri-user-line text-foreground-500"></i>
                </div>
                <div>
                  <p className="text-foreground-200 text-sm font-medium">夜猫电影院编辑部</p>
                  <p className="text-foreground-600 text-xs">专注影视内容创作与推荐</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="分享">
                  <i className="ri-share-forward-line"></i>
                </button>
                <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer" aria-label="收藏">
                  <i className="ri-heart-line"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="mt-6">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-400 transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </article>
      </main>
    </>
  );
}